import { useCallback } from "react";

import type { ReservationDetailUpdateMailMagazineStatusInput } from "@/lib/gql/__generated__/graphql";

import * as MutationRepository from "../../repository/mutation";

export const useUpdateReservationDetailUpdateMailMagazineStatus = (hotelID: string, reservationID: string) => {
	const { onUpdateReservationDetailUpdateMailMagazineStatus: _onUpdateReservationDetailUpdateMailMagazineStatus } =
		MutationRepository.useReservationDetailUpdateMailMagazineStatusUpdateMutation();

	/**
	 * 予約詳細のメルマガ購読のステータスの変更を実行
	 */
	const onUpdateReservationDetailUpdateMailMagazineStatus = useCallback(
		(statusMailMagazine: ReservationDetailUpdateMailMagazineStatusInput["statusMailMagazine"]) => {
			const input: ReservationDetailUpdateMailMagazineStatusInput = {
				statusMailMagazine,
				hotelID,
				reservationID,
			} satisfies ReservationDetailUpdateMailMagazineStatusInput;
			_onUpdateReservationDetailUpdateMailMagazineStatus(input);
		},
		[_onUpdateReservationDetailUpdateMailMagazineStatus, hotelID, reservationID],
	);

	return {
		onUpdateReservationDetailUpdateMailMagazineStatus,
	};
};
